import { render, staticRenderFns } from "./previewInvoice.vue?vue&type=template&id=3b61443d&scoped=true&"
import script from "./previewInvoice.vue?vue&type=script&lang=js&"
export * from "./previewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./previewInvoice.vue?vue&type=style&index=0&id=3b61443d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61443d",
  null
  
)

export default component.exports